import React, { Component } from "react"


class pdfGeneration extends Component {
  
    componentDidMount() {
    }

}

export default pdfGeneration


// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/components/pdfGen/pdfGeneration.js